import { writable } from 'svelte/store';


let searchParams = new URLSearchParams(window.location.search);

export const urlAirplaneCategories = writable(getArrayFromParam('airplaneCategories'));
urlAirplaneCategories.subscribe(value => {
    setParamFromArray("airplaneCategories", value)
})

export const urlCategories = writable(getArrayFromParam('categories'));
urlCategories.subscribe(value => {
    setParamFromArray("categories", value)
})

export const urlCountries = writable(getArrayFromParam('countries'));
urlCountries.subscribe(value => {
    setParamFromArray("countries", value)
})

export const urlRegistrations = writable(getArrayFromParam('registrations'));
urlRegistrations.subscribe(value => {
    setParamFromArray("registrations", value)
})

export const urlAirlineOperators = writable(getArrayFromParam('airlineOperators'));
urlAirlineOperators.subscribe(value => {
    setParamFromArray("airlineOperators", value)
})

export const urlCapturePlaces = writable(getArrayFromParam('capturePlaces'));
urlCapturePlaces.subscribe(value => {
    setParamFromArray("capturePlaces", value)
})
export const urlCaptureDates = writable(getArrayFromParam('captureDates'));
urlCaptureDates.subscribe(value => {
    setParamFromArray("captureDates", value)
})

export const urlDoubleSeater = writable(getBoolFromParam('doubleSeater'));
urlDoubleSeater.subscribe(value => {
    setParamFromBool("doubleSeater", value)
})

export const urlSpecialPaint = writable(getBoolFromParam('specialPaint'));
urlSpecialPaint.subscribe(value => {
    setParamFromBool("specialPaint", value)
})

export const urlFlares = writable(getBoolFromParam('flares'));
urlFlares.subscribe(value => {
    setParamFromBool("flares", value)
})

export const urlAfterburner = writable(getBoolFromParam('afterburner'));
urlAfterburner.subscribe(value => {
    setParamFromBool("afterburner", value)
})

export const urlLandingGear = writable(getBoolFromParam('landingGear'));
urlLandingGear.subscribe(value => {
    setParamFromBool("landingGear", value)
})

export const urlBreakParachute = writable(getBoolFromParam('breakParachute'));
urlBreakParachute.subscribe(value => {
    setParamFromBool("breakParachute", value)
})

export const urlWaterPlane = writable(getBoolFromParam('waterpane'));
urlWaterPlane.subscribe(value => {
    setParamFromBool("waterpane", value)
})

export const urlStatic = writable(getBoolFromParam('static'));
urlStatic.subscribe(value => {
    setParamFromBool("static", value)
})

export const urlCivil = writable(getBoolFromParam('civil'));
urlCivil.subscribe(value => {
    setParamFromBool("civil", value)
})

export const urlMuseum = writable(getBoolFromParam('museum'));
urlMuseum.subscribe(value => {
    setParamFromBool("museum", value)
})

export const urlCloseup = writable(getBoolFromParam('closeup'));
urlCloseup.subscribe(value => {
    setParamFromBool("closeup", value)
})

export const urlMilitary = writable(getBoolFromParam('military'));
urlMilitary.subscribe(value => {
    setParamFromBool("military", value)
})
//Custom URL Functions
function setParamFromArray(paramName, value) {
    if(value.length > 0) {
        searchParams.set(paramName, value.join('-'));
    }
    else {
        searchParams.delete(paramName);
    }
    updateURL();
}

function getArrayFromParam(param) {
    let param_value = searchParams.get(param);
    if(param_value !== null) {
        return param_value.split('-')
    }
    return [];
}

//Custom URL Functions
function setParamFromBool(paramName, value) {
    if(value) {
        searchParams.set(paramName, 'true');
    }
    else {
        searchParams.delete(paramName);
    }
    updateURL();
}

function getBoolFromParam(param) {
    let param_value = searchParams.get(param);
    if(param_value !== null && param_value === 'true') {
        return true;
    }
    return false;
}

function updateURL() {
    let newRelativePathQuery = window.location.pathname
    let searchParamsString = searchParams.toString();
    if(searchParamsString.length > 0) {
        newRelativePathQuery += '?' + searchParams.toString();
    }
    history.pushState(null, '', newRelativePathQuery);
}
